var _g, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_25777",
    "data-name": "Group 25777",
    transform: "translate(-835 -583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25770",
    "data-name": "Group 25770",
    transform: "translate(841 586)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M21,30H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H15l9,9V27A3,3,0,0,1,21,30ZM15,1.75h0V7.5A1.5,1.5,0,0,0,16.5,9h5.75Z",
    fill: "#217346"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "X",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25775",
    "data-name": "Group 25775",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14050",
    "data-name": "Path 14050",
    d: "M8.17,18.64l-2.7-5.06H8.24l.85,1.89c.24.48.46,1,.75,1.68H9.9c.24-.66.47-1.2.66-1.68l.77-1.89H14l-2.69,5.17L14.14,24H11.37l-.97-2c-.26-.53-.5-1.07-.75-1.71H9.58c-.24.64-.48,1.18-.7,1.71L8,24H5.31Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14051",
    "data-name": "Path 14051",
    d: "M15.61,22.66a1.48,1.48,0,1,1,.412,1.075,1.48,1.48,0,0,1-.412-1.075Zm.32-7.18-.08-2.2h2.48l-.08,2.2-.35,4.76H16.28Z",
    fill: "#fff"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3855",
    "data-name": "Rectangle 3855",
    width: 36,
    height: 36,
    transform: "translate(835 583)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsm);
export default __webpack_public_path__ + "static/media/XLSM.4805fddb169038915a508c99f842f38d.svg";
export { ForwardRef as ReactComponent };